module.exports = __webpack_public_path__ + "images/emoji/basketball.7d53f2e03c4bf4c23e4c.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/basketball.png
// module id = S060
// module chunks = 13